import { Grid, Link, Typography } from "@mui/material";

export const DetailsItem = ({ styles, title, item, md, isLink }) => {
  return (
    <Grid container wrap="nowrap" md={md} marginBottom={styles.marginBottom}>
      <Grid item xs>
        <Typography
          variant="subtitle2"
          gutterBottom
          color={styles.title.fontColor}
          fontWeight={styles.title.FontWeight}
        >
          {title}
        </Typography>
        {isLink ? (
          <Link
            href={item || "#"}
            target="_blank"
            rel="noopener noreferrer" // Recommended for security reasons
            fontSize={styles.ingredient.fontSize}
            fontWeight={styles.ingredient.fontWeight}
          >
            {item || "--"}
          </Link>
        ) : (
          <Typography
            fontSize={styles.ingredient.fontSize}
            fontWeight={styles.ingredient.fontWeight}
          >
            {item || "--"}
          </Typography>
        )}
      </Grid>
    </Grid>
  );
};
